(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3465],{

/***/ 55724:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/color-code",
      function () {
        return __webpack_require__(39990);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ color_code; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(25384);
// EXTERNAL MODULE: ./reusable/ContentWithForm.tsx + 4 modules
var ContentWithForm = __webpack_require__(88551);
// EXTERNAL MODULE: ./api/delek.ts
var delek = __webpack_require__(55417);
// EXTERNAL MODULE: ./typings/contentPage.ts
var contentPage = __webpack_require__(96860);
;// CONCATENATED MODULE: ./components/pages/ColorCodePage.tsx




var ColorCodePage = function() {
    var buttons = [
        {
            value: "licenseNumber",
            name: "מס׳ לוחית רישוי"
        },
        {
            value: "chassis",
            name: "מס׳ שלדה"
        }, 
    ];
    var headerText = [
        "לכל צבע יש קוד משלו. כדי להבטיח שצבע מסוים יהיה זהה בדיוק לצבע המקורי, יש להקליד כאן את מספר לוחית הרישוי או השלדה – ונציג את קוד הצבע של המאזדה שלך", 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWithForm/* default */.Z, {
        title: "בדיקת קוד צבע",
        headerText: headerText,
        background: [
            "/img/colorcodemobile.jpg",
            "/img/colorcode.jpg"
        ],
        buttons: buttons,
        inputLabel: "מס׳ לוחית רישוי (משמאל לימין)",
        inputType: "text",
        submitText: "לבדיקה",
        bottomTitle: "שירות הלקוחות שלנו זמין בשבילך לכל עניין:",
        phoneNumber: "*2880",
        getData: delek/* getColorCodes */.mK,
        type: contentPage/* ContentItemType.COLOR */.o.COLOR,
        page: "color",
        breadCrumbName: "ColorCode"
    });
};
/* harmony default export */ var pages_ColorCodePage = (ColorCodePage);

;// CONCATENATED MODULE: ./src/pages/color-code.tsx



var ColorCode = function(param) {
    var seo = param.seo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
                data: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_ColorCodePage, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var color_code = (ColorCode);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4245,2669,6808,6104,8551,9774,2888,179], function() { return __webpack_exec__(55724); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);